import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "tui-date-table-body"
};
var _hoisted_2 = {
  class: "tui-date-table-body-weeks"
};
var _hoisted_3 = ["aria-label"];
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "tui-date-table-body-days-item-cell-text"
};
import { computed, ref, getCurrentInstance, nextTick, watch } from '../../../adapter-vue';
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/zh-cn';
import { isPC } from '../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'date-table',
  props: {
    type: {
      type: String,
      default: 'range' // "single"/"range"
    },
    currentPanelDate: {
      type: Dayjs,
      default: () => dayjs()
    },
    // type 为 single 时特有属性
    date: {
      type: Dayjs,
      default: null
    },
    // type 为 range 时特有属性
    startDate: {
      type: Dayjs,
      default: null
    },
    endDate: {
      type: Dayjs,
      default: null
    }
  },
  emits: ['pick'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    // vue 实例
    var instance = getCurrentInstance();
    // 面板行数
    var tableRows = ref([[], [], [], [], [], []]);
    var currentPanelDateObject = ref(dayjs(props.currentPanelDate || null));
    var dateObject = ref(dayjs(props.date || null));
    var startDateObject = ref(dayjs(props.startDate || null));
    var endDateObject = ref(dayjs(props.endDate || null));
    var WEEKS_CONSTANT = computed(() => {
      return dayjs.weekdaysShort();
    });
    // 表头数据
    var WEEKS = computed(() => WEEKS_CONSTANT.value.map(w => w.substring(1)));
    // 表格开始日期
    var startDateOnTable = computed(() => {
      var _currentPanelDateObje;
      var startDayOfMonth = (_currentPanelDateObje = currentPanelDateObject.value) === null || _currentPanelDateObje === void 0 ? void 0 : _currentPanelDateObje.startOf('month');
      return startDayOfMonth === null || startDayOfMonth === void 0 ? void 0 : startDayOfMonth.subtract((startDayOfMonth === null || startDayOfMonth === void 0 ? void 0 : startDayOfMonth.day()) || 7, 'day');
    });
    // 表格数据
    var rows = computed(() => {
      var _currentPanelDateObje2;
      var rows_ = tableRows.value;
      var cols = WEEKS.value.length;
      // 当月第一天
      var startOfMonth = (_currentPanelDateObje2 = currentPanelDateObject.value) === null || _currentPanelDateObje2 === void 0 ? void 0 : _currentPanelDateObje2.startOf('month');
      var startOfMonthDay = (startOfMonth === null || startOfMonth === void 0 ? void 0 : startOfMonth.day()) || 7; // day of this month first day
      var dateCountOfMonth = startOfMonth === null || startOfMonth === void 0 ? void 0 : startOfMonth.daysInMonth(); // total days of this month
      var count = 1;
      // 循环填充表格，6行7列
      for (var row = 0; row < tableRows.value.length; row++) {
        for (var col = 0; col < cols; col++) {
          var _startDateOnTable$val, _dateObject$value, _startDateObject$valu, _endDateObject$value;
          var cellDate = (_startDateOnTable$val = startDateOnTable.value) === null || _startDateOnTable$val === void 0 ? void 0 : _startDateOnTable$val.add(count, 'day');
          var text = cellDate === null || cellDate === void 0 ? void 0 : cellDate.date();
          // 对于 type === "single", 选中传入日期
          // 对于 type === "range", 选中传入的开始与结束的日期
          var isSelected = props.type === 'single' && (cellDate === null || cellDate === void 0 ? void 0 : cellDate.format('YYYY-MM-DD')) === ((_dateObject$value = dateObject.value) === null || _dateObject$value === void 0 ? void 0 : _dateObject$value.format('YYYY-MM-DD'));
          var isSelectedStart = props.type === 'range' && (cellDate === null || cellDate === void 0 ? void 0 : cellDate.format('YYYY-MM-DD')) === ((_startDateObject$valu = startDateObject.value) === null || _startDateObject$valu === void 0 ? void 0 : _startDateObject$valu.format('YYYY-MM-DD'));
          var isSelectedEnd = props.type === 'range' && (cellDate === null || cellDate === void 0 ? void 0 : cellDate.format('YYYY-MM-DD')) === ((_endDateObject$value = endDateObject.value) === null || _endDateObject$value === void 0 ? void 0 : _endDateObject$value.format('YYYY-MM-DD'));
          // 对于 type === "range", 是否在选择区间中
          var isInRange = (cellDate === null || cellDate === void 0 ? void 0 : cellDate.isSameOrBefore(endDateObject.value, 'day')) && (cellDate === null || cellDate === void 0 ? void 0 : cellDate.isSameOrAfter(startDateObject.value, 'day'));
          var type = 'normal';
          if (count < startOfMonthDay) {
            // 上个月日期
            type = 'prev-month';
          } else if (count - startOfMonthDay >= dateCountOfMonth) {
            // 下个月日期
            type = 'next-month';
          }
          rows_[row][col] = {
            type,
            date: cellDate,
            text,
            isSelected: isSelected || isSelectedStart || isSelectedEnd,
            isSelectedStart,
            isSelectedEnd,
            isInRange
          };
          count++;
        }
      }
      return rows_;
    });
    var handlePick = cell => {
      if ((cell === null || cell === void 0 ? void 0 : cell.type) !== 'normal') {
        return;
      }
      emit('pick', cell);
    };
    watch(() => [props.currentPanelDate, props.date, props.startDate, props.endDate], () => {
      currentPanelDateObject.value = dayjs(props.currentPanelDate || null);
      dateObject.value = dayjs(props.date || null);
      startDateObject.value = dayjs(props.startDate || null);
      endDateObject.value = dayjs(props.endDate || null);
      nextTick(() => {
        var _instance$proxy;
        instance === null || instance === void 0 || (_instance$proxy = instance.proxy) === null || _instance$proxy === void 0 || _instance$proxy.$forceUpdate();
      });
    }, {
      deep: true,
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("table", {
        class: _normalizeClass(['tui-date-table', !_unref(isPC) && 'tui-date-table-h5']),
        cellspacing: "0",
        cellpadding: "0",
        role: "grid"
      }, [_createElementVNode("tbody", _hoisted_1, [_createElementVNode("tr", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WEEKS), item => {
        return _openBlock(), _createElementBlock("th", {
          key: item,
          class: "tui-date-table-body-weeks-item",
          "aria-label": item + '',
          scope: "col"
        }, _toDisplayString(_unref(TUITranslateService).t("time.".concat(item))), 9, _hoisted_3);
      }), 128))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rows), (row, rowKey) => {
        return _openBlock(), _createElementBlock("tr", {
          key: rowKey,
          class: "tui-date-table-body-days"
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (col, colKey) => {
          return _openBlock(), _createElementBlock("td", {
            key: colKey,
            class: _normalizeClass(['tui-date-table-body-days-item', col.type])
          }, [_createElementVNode("div", {
            class: _normalizeClass(['tui-date-table-body-days-item-cell', col.isSelected && 'selected', col.isSelectedStart && 'selected-start', col.isSelectedEnd && 'selected-end', col.isInRange && 'range']),
            onClick: $event => handlePick(col)
          }, [_createElementVNode("span", _hoisted_5, _toDisplayString(col.text), 1)], 10, _hoisted_4)], 2);
        }), 128))]);
      }), 128))])], 2);
    };
  }
});